export enum EventCodes {
  Ev0001 = 'RMAvailabilityReactApp.InlineSaveFreeFlex',
  Ev0002 = 'RMAvailabilityReactApp.PageVisit.EditAvailability',
  Ev0003 = 'RMAvailabilityReactApp.TrafficSource.StartDateInUrl',
  Ev0004 = 'RMAvailabilityReactApp.TrafficSource.EditAvailability',
  Ev0005 = 'RMAvailabilityReactApp.UserAction.UpdateClicked',
  Ev0006 = 'RMAvailabilityReactApp.PageLoad.EditAvailability',
}

export enum TelemetryFeatures {
  EditAvailability = 'EditAvailability',
}

export enum TelemetryActions {
  PageVisit = 'PageVisit',
  TrafficSource = 'TrafficSource',
  UserAction = 'UserAction',
  PageLoad = 'PageLoad',
}
